<template>
  <li class="timeline-item__element">
    <div class="timeline-item__icon">
      <slot name="icon" />
    </div>
    <div class="timeline-item__content">
      <p class="timeline-item__headline"><slot name="headline" /></p>
      <div class="timeline-item__body"><slot name="body" /></div>
      <div class="timeline-item__image"><slot name="image" /></div>
    </div>
    <div class="timeline-item__datetime"><slot name="time" /></div>
  </li>
</template>

<script>
export default {
  name: 'TimelineItem',
}
</script>

<style lang="scss" scoped>
.timeline-item {
  &__element {
    flex-flow: row;
    position: relative;
    display: flex;
    width: 100%;
    padding: 1rem 0.5rem;
    margin: 0;
    &::before {
      content: '';
      position: absolute;
      bottom: -1px;
      top: -1px;
      left: -9px;
      width: 3px;
      background-color: green;
    }
    &::after {
      content: '';
      position: absolute;
      top: 1.5rem;
      left: -0.45rem;
      transform: translate(-50%, -50%);
      height: 21px;
      width: 21px;
      border: 3px solid white;
      border-radius: 15px;
      background-color: green;
    }
    &:first-of-type {
      &::before {
        top: 1.5rem;
      }
    }
  }
  &__icon {
    margin: 0 1rem;
  }
  &__content {
    flex-grow: 1;
  }
  &__image {
    margin-top: 10px;

    img {
      max-width: 100%;
    }
  }
  &__headline {
    margin: 0 0 0.5rem 0;
    font-size: 1.15rem;
  }
  &__datetime {
    min-width: 160px;
    font-size: 1.1rem;
    color: var(--form-control-label-color);
    text-align: right;
  }
}
</style>
